import { useMaterialModel } from 'api';
import { BaleEvidenceGallery, UploadOptionsButton, useSiteMaterial, useToggleCamera } from 'features';
import { useTranslation } from 'i18n';
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ActionRow, Button, Grid, Page, Section, Typography, useBreakpoint } from 'ui';

import { SiteHeader } from '../../components/SiteHeader/SiteHeader';

export const BalePhotos = () => {
  const { t } = useTranslation('orders');
  const { data: siteMaterial } = useSiteMaterial();
  const { isCameraOpen, toggle: toggleCamera } = useToggleCamera();
  const { isMobile } = useBreakpoint();
  const filePickerRef = useRef<HTMLInputElement>(null);
  const model = useMaterialModel(String(siteMaterial?.public_id));

  if (!siteMaterial) {
    return <Typography>{t('balePhotosPage.materialNotFound')}</Typography>;
  }

  const handleFileSelect = () => {
    filePickerRef.current?.click();
  };

  return (
    <Page>
      <Page.Title title={t('balePhotosPage.pageTitle')} />
      <Page.Divider />
      <Grid container>
        <Grid
          size={{
            md: 4,
            xs: 12,
          }}
        >
          <Section title={t('balePhotosPage.sections.siteDetails')}>
            <SiteHeader siteMaterial={siteMaterial} />
          </Section>
        </Grid>
        <Grid
          size={{
            md: 8,
            xs: 12,
          }}
        >
          <Section
            title={t('balePhotosPage.sections.evidence')}
            action={
              <ActionRow>
                <Button size="large" fullWidth variant="secondary" component={Link} to="edit">
                  {t('balePhotosPage.actions.edit')}
                </Button>
                <UploadOptionsButton onUpload={handleFileSelect} onOpenCamera={toggleCamera} isMobile={isMobile} />
              </ActionRow>
            }
          >
            <BaleEvidenceGallery
              onToggleCamera={toggleCamera}
              isCameraOpen={isCameraOpen}
              filePickerRef={filePickerRef}
              siteMaterial={siteMaterial}
              model={model}
            />
          </Section>
        </Grid>
      </Grid>
    </Page>
  );
};
